export default "__VITE_ASSET__bydQrSLA__"